import React from 'react';
import { Grid } from '../../node_modules/@material-ui/core';
import '../Loyalty.css';
import Lottie from 'react-lottie';
import * as animationData from '../restless_gift.json';

const LoyaltyItem = props => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
  return (
    <div className='redeemable-container'>
      <button className='redeemable-item-button' onClick={props.redeem}>
        <Grid container spacing={0}>
          <div>
            {/* <img className="free-icon" src="./free.png" /> */}
            <Grid item xs={12}>
              <div className='redeemable-item-unlocked'>
                <div className='inclined-div'>FREE!</div>
                <div className='gift-icon-container'>
                  {' '}
                  <img className='free-icon' src='./gift (3).png' />
                </div>
                <div className='redeemable-text'>{props.name}</div>
              </div>
              <div className='redeem-now-text'>200 points</div>
            </Grid>
          </div>
        </Grid>
      </button>
    </div>
  );
};

export default LoyaltyItem;



// WEBPACK FOOTER //
// ./src/components/LoyaltyItem.js